import { Flex, Grid } from "@chakra-ui/react";
import { KanguCargobrProvider } from "../../../contexts/KanguCargobrContext";

export function Layout({ children }) {
  return (
      <Flex flexDir="column" maxW="1430px" w="100%" margin="0 auto" mt="2rem" mb="4rem" color="#616162">
        {children}
      </Flex>
  );
}
